import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["field", "submit", "submitLabel"]
  static values = { texts: Object }

  connect() {
    this.refresh()
  }

  refresh() {
    const selectedKeys = this.fieldTargets
      .filter((field) => field.checked && !field.disabled)
      .map((field) => field.value)
    this.submitTarget.disabled = selectedKeys.length === 0
    this.submitLabelTarget.textContent = this.textsValue.apply.replace("%{count}", selectedKeys.length)
    this.dispatch("selection-change", { detail: { selectedKeys } })
  }
}
